module.exports = __webpack_public_path__ + "static/media/arrow-down.4f097a4f.svg";